import * as React from "react";
import { SVGProps } from "react";

const Hackenai = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 854 854" {...props}>
    <path
      fill="#3ef2d0"
      d="M797.1 0v170.8h-56.9V0h-56.9v170.8h-56.9V0h-56.9v170.8H284.7V0h-56.9v227.7h569.3v56.9H170.8V0h-56.9v284.7h-57V0H0v626.3h56.9V455.5h56.9v170.8h56.9V455.5h56.9v170.8h56.9V455.5h284.7v170.8h56.9V398.6H56.9v-56.9h626.2v284.7H740V341.6h56.9v284.7H854V0h-56.9zM97.6 764.5V797H24.4v-32.5H0V854h24.4v-32.5h73.2V854H122v-89.5H97.6zm463.6 57h-24.4V854h24.4v-32.5zm0-57h-24.4V797h-73.2v-32.5h-24.4V854h24.4v-32.5h73.2l24.4-24.4v-32.6zm-309.1 0H146.4V854h24.4v-32.5H244V854h24.4v-89.5h-16.3zm-81.3 32.6V789H244v8.1h-73.2zm244-8.2v-24.4h-122V854h122v-24.4h-97.6v-40.7h97.6zm292.8 0v-24.4h-122V854h122v-24.4H610v-8.1h97.6v-24.4H610V789h97.6zm122-24.4v56.9l-73.2-56.9H732V854h24.4v-56.9l73.2 56.9H854v-89.5h-24.4z"
    />
  </svg>
);

export default Hackenai;
